<template>
<div class="chapter">
<div class="inner_page">
<p class="ct-1"><span epub:type="pagebreak" id="page_ix" title="ix"> CONTENTS</span></p>
<p class="toc"><a href="#/foreword#for1" id="fo1">Foreword</a></p>
<p class="toc"><a href="#/acknowledgments#acks1" id="ack1">Acknowledgments</a></p>
<p class="toc"><a href="#/introduction#intr1" id="int1">Introduction</a></p>
<p class="toc"><a href="#/chapter01#ch-1" id="toc-1">Chapter 1:<span class="spa">The Dark Side</span></a></p>
<p class="toc"><span href="#/chapter02#ch-2" id="toc-2" title="Link target outside of Sample">Chapter 2:<span class="spa">Purpose in Pain</span></span></p>
<p class="toc"><span href="#/chapter03#ch-3" id="toc-3" title="Link target outside of Sample">Chapter 3:<span class="spa">Tear Down These Walls</span></span></p>
<p class="toc"><span href="#/chapter04#ch-4" id="toc-4" title="Link target outside of Sample">Chapter 4:<span class="spa">Reinforced Walls</span></span></p>
<p class="toc"><span href="#/chapter05#ch-5" id="toc-5" title="Link target outside of Sample">Chapter 5:<span class="spa">Scarlet Letter</span></span></p>
<p class="toc"><span href="#/chapter06#ch-6" id="toc-6" title="Link target outside of Sample">Chapter 6:<span class="spa">Potter’s Field</span></span></p>
<p class="toc"><span href="#/chapter07#ch-7" id="toc-7" title="Link target outside of Sample">Chapter 7:<span class="spa">Snake Bitten</span></span></p>
<p class="toc"><span href="#/chapter08#ch-8" id="toc-8" title="Link target outside of Sample">Chapter 8:<span class="spa">Collateral Damage</span></span></p>
<p class="toc"><span href="#/chapter09#ch-9" id="toc-9" title="Link target outside of Sample">Chapter 9:<span class="spa">The Judas Goat</span></span></p>
<p class="toc"><span href="#/chapter10#ch-10" id="toc-10" title="Link target outside of Sample">Chapter 10: Orphan Spirit</span></p>
<p class="toc"><span href="#/chapter11#ch-11" id="toc-11" title="Link target outside of Sample">Chapter 11: Journey to Wholeness</span></p>
<p class="toc"><span href="#/chapter12#ch-12" id="toc-12" title="Link target outside of Sample">Chapter 12: Right as Rain</span></p>
<p class="toc"><span href="#/notes#notes1" id="not1" title="Link target outside of Sample">Notes</span></p>
<p class="toc"><span href="#/about_the_author#abs1" id="ab1" title="Link target outside of Sample">About the Author</span></p>
<p class="toc"><span href="#/contect_the_author#sus1" id="cu" title="Link target outside of Sample">Contact the Author</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?0d91ddb5